import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LayoutDashboard, History, Settings, LogOut, CreditCard, Building, FastForward, Calendar, Lock } from 'lucide-react';
import { MonthContext } from '../context/MonthContext';

const DashboardLayout = ({ setAuth }) => {
  const navigate = useNavigate();
  const { selectedMonth, setSelectedMonth, monthsStatus } = React.useContext(MonthContext);

  const doLogout = () => {
    localStorage.removeItem('token');
    setAuth(false);
    navigate('/login');
  };

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer', ...{} }}>
          <img src="/favicon.svg" alt="Tallem" style={{ width: '36px', height: '36px', borderRadius: '8px', objectFit: 'contain' }} />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ whiteSpace: 'nowrap', fontSize: '1.1rem' }}>Facturation</span>
            <span style={{ fontSize: '0.70rem', color: 'var(--text-secondary)' }}>(v{__APP_VERSION__})</span>
          </div>
        </div>
        
        <div style={{ padding: '0 1rem', marginBottom: '1rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: 'var(--bg-secondary)', padding: '0.5rem', borderRadius: '8px', border: `1px solid ${monthsStatus[selectedMonth] ? 'rgba(244, 63, 94, 0.5)' : 'var(--glass-border)'}` }}>
            {monthsStatus[selectedMonth] ? <Lock size={16} color="#f43f5e" /> : <Calendar size={16} color="var(--text-secondary)" />}
            <select 
              value={selectedMonth} 
              onChange={(e) => setSelectedMonth(e.target.value)}
              style={{ width: '100%', background: 'transparent', border: 'none', color: 'var(--text-primary)', outline: 'none', fontSize: '0.875rem', cursor: 'pointer' }}
            >
              <option value="all">Tous les mois</option>
              {(() => {
                const opts = [];
                const now = new Date();
                for (let i = -3; i < 12; i++) {
                  const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
                  const mStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
                  const mName = d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
                  const baseLabel = mName.charAt(0).toUpperCase() + mName.slice(1);
                  const isClosed = monthsStatus[mStr];
                  const label = (isClosed ? '✅ ' : '⏳ ') + baseLabel;
                  opts.push(<option key={mStr} value={mStr} style={{ color: isClosed ? '#10b981' : 'inherit' }}>{label}</option>);
                }
                return opts;
              })()}
            </select>
          </div>
        </div>

        <nav className="nav-menu">
           <NavLink to="/" end className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
              <LayoutDashboard size={20} />
              Accueil
           </NavLink>
           <NavLink to="/workflow" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
              <FastForward size={20} />
              Workflow
           </NavLink>
           <NavLink to="/history" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
              <History size={20} />
              Dépenses
           </NavLink>
           <NavLink to="/onedrive" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
              <Building size={20} />
              Dossier Gestion
           </NavLink>
           <NavLink to="/expense-notes" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
              <CreditCard size={20} />
              Notes de frais
           </NavLink>
           <NavLink to="/rebilling" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
              <Building size={20} />
              Refacturation
           </NavLink>
           <NavLink to="/statements" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
              <CreditCard size={20} />
              Relevés Qonto
           </NavLink>
           <NavLink to="/settings" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
              <Settings size={20} />
              Réglages
           </NavLink>
        </nav>
        
        <div style={{ marginTop: 'auto' }}>
           <button onClick={doLogout} className="nav-link" style={{ width: '100%', background: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left' }}>
              <LogOut size={20} color="var(--danger)" />
              <span style={{ color: 'var(--danger)' }}>Déconnexion</span>
           </button>
        </div>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
